import styled from 'styled-components';
import React, { FC } from 'react';

export const StBackButton = styled.a`
    margin-right: 10px;
    font-size: 28px;
    line-height: 1;
`;

const StDiv = styled.div`
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const StHeadline = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 20px 25px;
`;

interface Props {
    title: string | undefined;
}

export const SortingHeadLine: FC<Props> = ({ title }) => {
    return (
        <StHeadline>
            <StDiv>
                {/* eslint-disable-next-line no-script-url */}
                <StBackButton onClick={() => window.history.back()}>
                    <i className="material-icons" style={{ fontSize: 'inherit' }}>
                        arrow_back
                    </i>
                </StBackButton>
                {title}
            </StDiv>
        </StHeadline>
    );
};
